import { IssueInfoGridColumnDTO } from '../interface/issue-info.interface';
import {
  IssueGridRow,
  IssueGridRecord,
  IssuePrior2018GridColumnDTO,
  IssuePrior2018RecordDTO,
  After2017HeaderLabels,
  After2017ApiResponseDTO,
  After2017IssueRecordDTO,
} from '../interface/issues-2017-2018.interface';

export const PRIOR_2018_COLUMNS = ['US', 'General', 'FOGEI', 'FORI', 'Passive', 'Capital Gain'];

export const PRIOR_2018_ROWS: IssueGridRow[] = [
  {
    id: 1,
    label: 'TI b/f 199',
  },
  {
    id: 2,
    label: '199 Deduct',
  },
  {
    id: 3,
    label: 'FTC',
  },
  {
    id: 4,
    label: 'GBC',
  },
];

export const DUMMY_RECORDS: IssueGridRecord[] = [
  {
    id: 1,

    metadata: {
      arFilingId: '20-22',
      arIssueId: 'SAA016',
      irsIssueId: '',

      saa: '16',
      submission: 'Completed',
      spDoc: 'SP001',

      epAdj: 'Yes',
      tbbsAdj: 'Yes',
      corpTaxAdj: 'Completed',

      npaMessage: 'NPA ties AR/SAA',

      is199: true,
      isAsc740: true,
    },

    values: {
      us: null,
      general: null,
      fogei: null,
      fori: null,
      passive: null,
      capitalGain: null,
    },
  },
];

export const ISSUE_2018_EXISTING_COLUMNS: IssueInfoGridColumnDTO[] = [
  {
    key: 'empty',
    label: '',
  },
  {
    key: 'us',
    label: 'US',
  },
  {
    key: 'general',
    label: 'General',
  },
  {
    key: 'fogei',
    label: 'FOGEI',
  },
  {
    key: 'fori',
    label: 'FORI',
  },
  {
    key: 'passive',
    label: 'Passive',
  },
  {
    key: 'capitalGain',
    label: 'Capital Gain',
  },
];

export const ISSUE_2018_COMMON_COLUMNS: IssueInfoGridColumnDTO[] = [
  {
    key: 'issueInfo',
    label: '',
    lines: ['Issue ID', 'Year', 'Entity'],
  },
  {
    key: 'empty',
    label: '',
  },
  {
    key: 'us',
    label: 'US',
  },
  {
    key: 'general',
    label: 'General',
  },
  {
    key: 'fogei',
    label: 'FOGEI',
  },
  {
    key: 'fori',
    label: 'FORI',
  },
  {
    key: 'passive',
    label: 'Passive',
  },
  {
    key: 'capitalGain',
    label: 'Capital Gain',
  },
];

export const ISSUE_INFO_ADDITIONAL_COLUMNS: IssuePrior2018GridColumnDTO[] = [
  {
    key: 'ar',
    label: '',
    lines: ['AR Filing ID', 'AR Issue ID', 'IRS Issue ID'],
  },
  {
    key: 'saa',
    label: '',
    lines: ['SAA #', 'Submission', 'SP Doc'],
  },
  {
    key: 'tbbs',
    label: '',
    lines: ['E&P Adj', 'TBBS Adj', 'Corptax Adj'],
  },
];

export const AFTER_2017_HEADER: After2017HeaderLabels[] = [
  {
    multiline: ['Issue ID', 'Year', 'Entity'],
    topLabel: null,
    subLabel: null,
    children: [],
  },
  {
    multiline: [],
    topLabel: null,
    subLabel: '',
    children: [],
  },
  {
    multiline: [],
    topLabel: null,
    subLabel: 'US',
    children: [],
  },
  {
    multiline: [],
    topLabel: 'Branch',
    subLabel: null,
    children: [
      {
        multiline: [],
        topLabel: null,
        subLabel: 'NOGI',
        children: [],
      },
      {
        multiline: [],
        topLabel: null,
        subLabel: 'CFOGI',
        children: [],
      },
    ],
  },
  {
    multiline: [],
    topLabel: 'No Branch',
    subLabel: null,
    children: [
      {
        multiline: [],
        topLabel: null,
        subLabel: 'NOGI',
        children: [],
      },
      {
        multiline: [],
        topLabel: null,
        subLabel: 'CFOGI',
        children: [],
      },
    ],
  },
  {
    multiline: [],
    topLabel: null,
    subLabel: 'Passive',
    children: [],
  },
  {
    multiline: [],
    topLabel: 'GILTI',
    subLabel: null,
    children: [
      {
        multiline: [],
        topLabel: null,
        subLabel: 'NOGI',
        children: [],
      },
      {
        multiline: [],
        topLabel: null,
        subLabel: 'FORI',
        children: [],
      },
    ],
  },
  {
    multiline: [],
    topLabel: null,
    subLabel: 'Capital Gain',
    children: [],
  },
];

export const AFTER_2017_ADDITIONAL_COLUMNS: After2017HeaderLabels[] = [
  {
    multiline: ['AR Filing ID', 'AR Issue ID', 'IRS Issue ID'],
    topLabel: null,
    subLabel: null,
    children: [],
  },
  {
    multiline: ['SAA #', 'Submission', 'SP Doc'],
    topLabel: null,
    subLabel: null,
    children: [],
  },
  {
    multiline: ['E&P Adj', 'TBBS Adj', 'Corptax Adj'],
    topLabel: null,
    subLabel: null,
    children: [],
  },
];

export const emptyIssuePrior2018Record: IssuePrior2018RecordDTO = {
  id: 0,
  isNPATied: '',
  deduction199: false,
  asC_740Flag: false,
  isCancelled: false,
  isFilled: false,
  rows: [
    {
      empty: 'TI b/f 199',
      us: '',
      general: '',
      fogei: '',
      fori: '',
      passive: '',
      capitalGain: '',
      ar: '',
      saa: '',
      tbbs: '',
    },
    {
      empty: '199 Deduct',
      us: '',
      general: '',
      fogei: '',
      fori: '',
      passive: '',
      capitalGain: '',
      ar: '',
      saa: '',
      tbbs: '',
    },
    {
      empty: 'FTC',
      us: '',
      general: '',
      fogei: '',
      fori: '',
      passive: '',
      capitalGain: '',
      ar: '',
      saa: '',
      tbbs: '',
    },
    {
      empty: 'GBC',
      us: '',
      general: '',
      fogei: '',
      fori: '',
      passive: '',
      capitalGain: '',
      ar: '',
      saa: '',
      tbbs: '',
    },
  ],
};

export const empty2018Record: After2017IssueRecordDTO = {
  id: 0,
  issueId: '',
  year: 0,
  entity: '',
  cfc: '',

  rows: [
    {
      label: 'TI',
      us: '',
      branchNogi: '',
      branchCfogi: '',
      nonBranchNogi: '',
      nonBranchCfogi: '',
      passive: '',
      giltiNogi: '',
      giltiFori: '',
      capitalGain: '',
    },
    {
      label: '',
      us: '',
      branchNogi: '',
      branchCfogi: '',
      nonBranchNogi: '',
      nonBranchCfogi: '',
      passive: '',
      giltiNogi: '',
      giltiFori: '',
      capitalGain: '',
    },
    {
      label: 'FTC',
      us: '',
      branchNogi: '',
      branchCfogi: '',
      nonBranchNogi: '',
      nonBranchCfogi: '',
      passive: '',
      giltiNogi: '',
      giltiFori: '',
      capitalGain: '',
    },
    {
      label: 'GBC',
      us: '',
      branchNogi: '',
      branchCfogi: '',
      nonBranchNogi: '',
      nonBranchCfogi: '',
      passive: '',
      giltiNogi: '',
      giltiFori: '',
      capitalGain: '',
    },
    {
      label: '',
      us: '',
      branchNogi: '',
      branchCfogi: '',
      nonBranchNogi: '',
      nonBranchCfogi: '',
      passive: '',
      giltiNogi: '',
      giltiFori: 'NPA ties AR/SAA',
      capitalGain: '',
    },
  ],
};
